export default function ({ app }) {

  try {
    if (
      localStorage.getItem('lang') !== null
    ) {
      app.i18n.locale = localStorage.getItem('lang')
    } else {
      localStorage.setItem('lang', 'th')
      app.i18n.locale = localStorage.getItem('lang')
    }
  } catch (error) {
    console.log(error)
  }
}
